export default "__VITE_ASSET__DvSx8$wJ__"